<template>
  <div v-if="index <= 9">
    <!-- <fragment v-for="(item, index) in shopNewsList" :key="itemShopnewsChild.index"> -->
      <div class="topshopnew__list__item" v-if="!isLoadingChild">
        <router-link class="itemstatus__new" :to="'/shop-news/' + itemShopnewsChild.id">
          <div
            class="itemstatus__new__banner"
            v-if="diffDate(itemShopnewsChild.acf?.start_date + ' ' + itemShopnewsChild.acf?.start_time) <= 7"
          >
            <img src="@/assets/img/top/portal_icon.svg" alt="" />
            <div class="itemstatus__new__banner__text">
              NEW
            </div>
          </div>
          <div
            class="item__img"
            v-if="itemShopnewsChild.acf?.news_image1 || itemShopnewsChild.acf?.title && itemShopnewsChild.acf?.news_image1 != '' || itemShopnewsChild.acf?.news_image1 != false"
            :style="{ backgroundImage: `url(${$func.formatUrl(itemShopnewsChild.acf?.news_image1)})` }"
          >
            <img
              :src="$func.formatUrl(itemShopnewsChild.acf?.news_image1)"
              :alt="itemShopnewsChild.acf?.title"
            />
          </div>
          <div
            class="item__img"
            v-if="itemShopnewsChild.acf?.news_image1 === '' || itemShopnewsChild.acf?.news_image1 === false"
            :style="{ backgroundImage: `url(${(urlNowRinting.url)})` }"
          >
            <img :src="urlNowRinting.url" :alt="urlNowRinting.alt" /> 
          </div>
          <div class="item__text">
            <span class="item__date" v-if="itemShopnewsChild.acf?.start_date">{{ formatDate(itemShopnewsChild.acf?.start_date) }}({{ formatWeekDay(itemShopnewsChild.acf?.start_date) }}) 更新</span>
            <ul class="item__cate" v-if="itemShopnewsChild.acf?.category">
              <li v-if="itemShopnewsChild.acf?.category">{{ itemShopnewsChild.acf?.category }}</li>
            </ul>
            <span class="item__title" v-if="itemShopnewsChild.acf?.title">{{ itemShopnewsChild.acf?.title }}</span>
            <div class="item__type" v-if="!itemShopnewsChild.acf?.relation_shop_guide">
              <div :class="itemShopnewsChild.acf?.shop_type === '飲食' ? 'item__type__tag' : 'item__type__tag tag--grey'" v-if="itemShopnewsChild.acf?.shop_type != null && itemShopnewsChild.acf?.shop_type != '' && itemShopnewsChild.acf?.shop_type === '飲食'">
                {{ itemShopnewsChild.acf?.shop_type }}
              </div>
              <div :class="itemShopnewsChild.acf?.shop_type === 'その他' ? 'item__type__tag tag--grey' : 'item__type__tag'" v-if="itemShopnewsChild.acf?.shop_type != null && itemShopnewsChild.acf?.shop_type != '' && itemShopnewsChild.acf?.shop_type === 'その他'">
                {{ itemShopnewsChild.acf?.shop_type }}
              </div>
              <div class="item__type__decs" v-if="itemShopnewsChild.acf?.shop_name || itemShopnewsChild.acf?.shop_number">{{ itemShopnewsChild.acf?.shop_number + '.' + itemShopnewsChild.acf?.shop_name }}</div>
            </div>
            <div class="item__type" v-if="itemShopnewsChild.acf?.relation_shop_guide">
              <div :class="itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_type === '飲食' ? 'item__type__tag' : 'item__type__tag tag--grey'" v-if="itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_type != null && itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_type != '' && itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_type === '飲食'">
                {{ itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_type }}
              </div>
              <div :class="itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_type === 'その他' ? 'item__type__tag tag--grey' : 'item__type__tag'" v-if="itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_type != null && itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_type != '' && itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_type === 'その他'">
                {{ itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_type }}
              </div>
              <div class="item__type__decs" v-if="itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_name || itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_id">{{ itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_id + '.' + itemShopnewsChild.acf?.relation_shop_guide_detail?.acf?.shop_name }}</div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="skeleton-parent" v-if="isLoadingChild">
        <PuSkeleton style="height: 300px;" :count="1"/>
      </div>
    <!-- </fragment> -->
  </div>
</template>

<script>
import CONSTANT from "../../constant.js";
import { formatDate, formatWeekDay, diffDate } from '@/utils/helper';

export default {
  name: "ItemShopnews",
  props: {
    itemShopnewsChild: {
      type: Object,
    },
    index: {
      type: Number
    },
    isLoadingChild: {
      type: Boolean
    }
  },
  data() {
    return {
      // shopNewsList: [],
      // isLoading: true,
      urlNowRinting: CONSTANT.dataImageNowrinting,
    };
  },
  components: {
    // Fragment,
  },
  computed: {
  },
  methods: {
    formatDate, 
    formatWeekDay, 
    diffDate
  },
};
</script>
